import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_DOCTOR_DOCUMENTS } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

// ✅ Create AsyncThunk for fetching doctor documents
export const fetchDocumentsReducer = createAsyncThunk(
  ACTION_DOCTOR_DOCUMENTS.fetch_doctor_documents,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getDocument}`,
      );

      // ✅ Success condition
      if (response?.data?.status === true || response?.status === 200) {
        return response.data;
      } else {
        const errorMessage = getLocalizedErrorMessage({ response }, i18n);
        toast.error(errorMessage);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error in fetching documents:", error);
      const errorMessage = getLocalizedErrorMessage(error, i18n);
      toast.error(errorMessage);
      return rejectWithValue(error?.response?.data || errorMessage);
    }
  },
);
